import { Button, Component, Node, _decorator } from 'cc';
import { IPreviewHistoryData } from '../../../../../../tableEngine/Script/Game/Data/DataObject/History/IHistoryData';

enum EventType {
    OPEN_MACHINE_RECORD_LIST = 'OPEN_MACHINE_RECORD_LIST',
}

const { ccclass, property } = _decorator;

@ccclass('BaseMachineRecord')
export default abstract class BaseMachineRecord extends Component {
    public static readonly EVENT_TYPE = EventType;

    @property(Button)
    protected readonly detailButton: Button = null;

    protected displayedData: IPreviewHistoryData = null;

    public onLoad() {
        this.detailButton.node.on(Node.EventType.TOUCH_END, () => {
            this.node.emit(EventType.OPEN_MACHINE_RECORD_LIST, this.displayedData);
        });
    }

    public display(data: IPreviewHistoryData) {
        this.displayedData = data;
        this.updateContent(data);
    }

    protected abstract updateContent(data: IPreviewHistoryData): void;
}
